<template>
  <div>
    <v-card
      v-for="(campsiteBookings, itineraryGroup) in itineraryGroups"
      :key="itineraryGroup"
    >
      <v-container class="purple white--text">
        <h4>Itinerary {{ itineraryGroup }}</h4>
      </v-container>

      <campsite-bookings
        v-for="campsiteBooking in campsiteBookings"
        :key="campsiteBooking.campsiteBookingID"
        :campsite-booking="campsiteBooking"
        :show-details="showDetails"
      >
        <!-- start actions -->
        <template slot="actions">
          <IconButton
            icon="fa-times-circle"
            tooltip="Delete Reservation"
            color="red"
            @click="remove({campsiteBookingID: campsiteBooking.campsiteBookingID})"
          />
        </template>
        <!-- end actions -->
        <!-- start additional content -->
        <template>
          <!-- party selection -->
          <v-form v-if="showParty">
            <v-container>
              <v-layout
                wrap
              >
                <v-flex
                  xs12
                  sm4
                >
                  <v-select
                    v-model="campsiteBooking.adult"
                    :items="partyOptions(campsiteBooking).adult"
                    label="Adult"
                    @input="updateParty(campsiteBooking)"
                  >
                    <option value="test">test</option>
                  </v-select>
                </v-flex>
                <v-flex
                  xs12
                  sm4
                >
                  <v-select
                    v-model="campsiteBooking.junior"
                    :items="partyOptions(campsiteBooking).junior"
                    label="Junior"
                    @input="updateParty(campsiteBooking)"
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm4
                >
                  <v-select
                    v-model="campsiteBooking.child"
                    :items="partyOptions(campsiteBooking).child"
                    label="Child"
                    @input="updateParty(campsiteBooking)"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </template>
        <!-- end content -->
      </campsite-Bookings>
      <!-- start gatepass -->
      <v-card-item>
        <v-layout justify-center>
          <v-btn
            round
            color="primary"
            dark
            @click="createGatePass({itineraryGroup: itineraryGroup})"
          >
            Add a non-resident gate pass
          </v-btn>
        </v-layout>
      </v-card-item>
      <GatePasses :itinerary-group="itineraryGroup"/>
    <!-- end gatePass -->
    </v-card>
  </div>
</template>

<script>
// import components
import { mapGetters, mapActions } from 'vuex'
import GatePasses from './GatePasses'

export default {
  components: {
    GatePasses
  },
  props: {
    showParty: {
      type: Boolean,
      default: false
    },
    showDetails: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      campsiteBookings: 'cart/campsiteBookings'
    }),
    itineraryGroups () {
      return this.campsiteBookings.reduce((groups, booking) => {
        const val = booking.itineraryGroup
        groups[val] = groups[val] || []
        groups[val].push(booking)
        return groups
      }, {})
    }
  },
  methods: {
    ...mapActions({
      getCart: 'cart/getCart',
      getCampsiteWeek: 'facilities/getCampsiteWeek',
      updateCampsiteBookingParties: 'itineraries/updateCampsiteBookingParties',
      deleteCampsiteBooking: 'cart/deleteCampsiteBooking',
      createGatePass: 'cart/createGatePass'
    }),
    remove (campsiteBooking) {
      this.deleteCampsiteBooking(campsiteBooking).finally(() => {
        this.getCampsiteWeek()
      })
    },
    partyOptions (campsiteBooking) {
      let capacity = campsiteBooking.campsiteCapacity
      let maxAdult = capacity - campsiteBooking.junior - campsiteBooking.child
      let maxJunior = capacity - campsiteBooking.adult - campsiteBooking.child
      let maxChild = capacity - campsiteBooking.adult - campsiteBooking.junior
      return {
        adult: Array.from(Array(maxAdult + 1), (val, index) => String(index)), // excludes 0
        junior: Array.from(Array(maxJunior + 1), (val, index) => String(index)),
        child: Array.from(Array(maxChild + 1), (val, index) => String(index))
      }
    },
    updateParty (campsiteBooking) {
      this.updateCampsiteBookingParties({
        campsiteBookingIDs: [campsiteBooking.campsiteBookingID],
        adult: campsiteBooking.adult,
        junior: campsiteBooking.junior,
        child: campsiteBooking.child
      })
    }
  }
}
</script>
